import React, { useEffect } from 'react'
import { routes } from '../../../../../constants/routes.constants'
import { Link } from 'react-router-dom'
import {
	TransactionNumber,
	Number,
	ConfirmationMessage,
	Contact,
	Email
} from '../styles.style'

const PointsTransferDetail = () => {
	let info = localStorage.UserPointsTransfer
		? JSON.parse(localStorage.UserPointsTransfer)
		: ''

	if (!info) {
		window.location.href = '/'
	} else {
		const { id, email } = info.data

		return (
			<div>
				<TransactionNumber>
					Número da transação: <Number>{id}</Number>
				</TransactionNumber>

				<ConfirmationMessage>
					Um e-mail de confirmação foi enviado para {email}
				</ConfirmationMessage>

				<Link
					to={`${routes.CLIENTE}/extrato`}
					className="extract-button"
					title="Consulte seu extrato">
					Consulte seu extrato
				</Link>

				<Contact>
					Em caso de dúvidas, envie um e-mail para{' '}
					<Email
						target="_blank"
						href="mailto:faleconosco@muviflex.com.br"
						title="faleconosco@muviflex.com.br">
						faleconosco@muviflex.com.br
					</Email>
				</Contact>
			</div>
		)
	}
}

export default PointsTransferDetail
